export const supabaseConfig = {
  url: import.meta.env.VITE_SUPABASE_URL || "",
  publishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "",
};

export const accessRequestEmail = import.meta.env.VITE_ACCESS_REQUEST_EMAIL || "jambole0192@gmail.com";

export const automaticAuthEmail = import.meta.env.VITE_AUTH_EMAIL_DELIVERY === "supabase";
